import { memo } from 'react';
import { DROPS_FILTERS_LIST, DROPS_STALE_TIME_MS, DROPS_TAB_SECTION_MAP, DropsFilter, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { Badge } from 'root/src/client/v2/common/components/badge/Badge';
import { useDropEventListFiltersContext } from 'root/src/client/v2/_pages/drops/contexts/dropEventListFilters.context';
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
import { DropSerializer } from 'root/src/shared/drops/drops.constants';
import { trpc } from 'root/src/client/v2/trpc/trpc';
export const DropsListFilter = memo(() => {
    const { filter, onFilterChange } = useDropEventListFiltersContext();
    const filtersList = useDropFiltersList();
    return (<ul role="list" className="flex justify-center sm:justify-start flex-wrap gap-3 sm:gap-2">
			{filtersList.map((option) => {
            const isActive = option.value === filter;
            return (<li key={option.value}>
						<button type="button" onClick={() => onFilterChange(option.value)}>
							<DropFilterBadge isActive={isActive}>{option.title}</DropFilterBadge>
						</button>
					</li>);
        })}
		</ul>);
});
const useDropFiltersList = () => {
    var _a, _b, _c, _d;
    const { authentication } = useAuthentication();
    const { tab } = useDropEventListFiltersContext();
    const dropsEligibleFilterQuery = trpc.drops.getDrops.useQuery({
        section: DROPS_TAB_SECTION_MAP[tab],
        serializer: DropSerializer.LIST_VIEW,
        dataFilter: DropsFilter.Eligible,
    }, {
        staleTime: DROPS_STALE_TIME_MS,
    });
    const dropsForYouFilterQuery = trpc.drops.getDrops.useQuery({
        section: DROPS_TAB_SECTION_MAP[tab],
        serializer: DropSerializer.LIST_VIEW,
        dataFilter: DropsFilter.ForYou,
    }, {
        staleTime: DROPS_STALE_TIME_MS,
    });
    const isEligibleDrops = Boolean(((_b = (_a = dropsEligibleFilterQuery.data) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) || 0);
    const isForYouDrops = Boolean(((_d = (_c = dropsForYouFilterQuery.data) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.length) || 0);
    return DROPS_FILTERS_LIST.filter((option) => {
        if (!(option === null || option === void 0 ? void 0 : option.groups) || !option.groups.length) {
            return true;
        }
        if (!isEligibleDrops && option.value === DropsFilter.Eligible) {
            return false;
        }
        if (!isForYouDrops && option.value === DropsFilter.ForYou) {
            return false;
        }
        const authGroups = (authentication === null || authentication === void 0 ? void 0 : authentication.groups) || [];
        return authGroups.some(authGroup => { var _a; return (_a = option.groups) === null || _a === void 0 ? void 0 : _a.includes(authGroup); });
    });
};
export const DropFilterBadge = memo((props) => {
    const { isActive, children } = props;
    return (<Badge data-active={isActive} className="capitalize data-[active=true]:motion-safe:animate-slide-up hover:brightness-100 motion-safe:duration-150 bg-primary brightness-50 data-[active=true]:brightness-100">
			{children}
		</Badge>);
});
